import { theme } from '@prose-ui';
import { legacyTheme, styled } from '@prose-ui/legacy';

import useResponsiveVariant from 'utils/useResponsiveVariant';

const Wrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  margin-top: 15px;

  ${legacyTheme.breakpoints.up('md')} {
    flex-direction: row;
    margin-top: 0;
    margin-left: 15px;
  }
`;

const ArrowLine = styled.svg`
  stroke: ${theme.colors.primary[400]};
  stroke-width: 2px;
`;

const ArrowChevron = styled.svg`
  fill: ${theme.colors.primary[400]};
`;

type RevealedArrowProps = {
  height?: number;
  width?: number;
};

export const RevealedArrow = ({ height = 0, width = 0 }: RevealedArrowProps) => {
  const { isDesktop } = useResponsiveVariant();
  return (
    <div>
      {/* Vertical arrow */}
      {!isDesktop && (
        <Wrapper>
          <ArrowLine height={`${height}px`} width="25px">
            <path d={`M 12.5 0 L 12.5 ${height} L 12.5 0 Z`} />
          </ArrowLine>

          <ArrowChevron height="12.5px" width="25px">
            <path d="M 11.5 0 h 2 v 4.5 l 5.5 -6 l 2.5 0 L 12.5 8.5 l -8 -8.5 l 2.5 0 L 11.5 4.5" />
          </ArrowChevron>
        </Wrapper>
      )}

      {/* Horizontal arrow */}
      {isDesktop && (
        <Wrapper>
          <ArrowLine height="25px" width={`${width}px`}>
            <path d={`M 0 12.5 L ${width} 12.5 L 12.5 12.5 Z`} />
          </ArrowLine>

          <ArrowChevron height="25px" width="12.5px">
            <path d="M 0 13.5 v -2 h 4.5 l -6 -6.5 l 0 -2.5 L 8.5 12.5 l -8.5 8 l 0 -2.5 L 4.5 13.5" />
          </ArrowChevron>
        </Wrapper>
      )}
    </div>
  );
};
